"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CTA_STATUS = void 0;
const CTA_STATUS = exports.CTA_STATUS = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  FAILED: 'FAILED',
  COMPLETE: 'COMPLETE',
  REVERTING: 'REVERTING'
};